import { BaseEntity } from "yt-ng-framework";

export class KozDokumentStavka extends BaseEntity{
    constructor(){
        super();
    }    

    KozDokumentID: number = null;
    Brfak: string = null;
    Datfak: Date = null;
    Datdpo: Date = null;
    Iznos: number = null;
    //OrgJedID: number = null;

    Deserialize(input:any){
        this.ID=input.ID;
        this.KozDokumentID=input.KozDokumentID;
        this.Brfak=input.Brfak;
        this.Datfak=input.Datfak;
        this.Datdpo=input.Datdpo;
        this.Iznos=input.Iznos;
       // this.OrgJedID=input.OrgJedID;
        return this;
    }

    Serialize(input:KozDokumentStavka){
        return input;
    }
}